(() => {

  const isKeyboardNavigation = () => {
    return document.body.classList.contains('keyboard-navigation');
  };

  const scrollToFocus = () => {
    const focusedElem = document.activeElement;
    focusedElem.scrollIntoView();
  };

  const onTab = () => {
    const body = document.querySelector('body');
    body.classList.add('keyboard-navigation');
    scrollToFocus();
  };

  const onCloseNav = () => {
    const body = document.querySelector('body');
    body.classList.remove('keyboard-navigation');
  }

  const init = () => {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' || event.code === 9) onTab();
    });

    const closeNavBtn = document.querySelector('.close-keyboard-navigation');
    closeNavBtn.addEventListener('click', onCloseNav);
    closeNavBtn.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.code === 13) onCloseNav();
    });
  };
  init();

})();
